// extracted by mini-css-extract-plugin
export default {"loadingSection":"styles_loadingSection__zC5dt"};